import { HStack } from "@/components/ui/hstack";
import React from 'react';
import { useWindowDimensions } from 'react-native';
import { Gesture, GestureDetector, TouchableWithoutFeedback } from "react-native-gesture-handler";
import Animated, { useSharedValue, withSpring, useAnimatedStyle, runOnJS } from 'react-native-reanimated';
import ListElement from './ListElement';
import { IconM } from '../media/IconsV2';

export default function DeletableListElement({ idx, element, avatar, marked, tag, onDelete }) {
    const { width: windowWidth } = useWindowDimensions()
    const translateX = useSharedValue(0)
    const startX = useSharedValue(0)

    const moveStyle = useAnimatedStyle(() => ({
        transform: [
            { translateX: translateX.value },
        ],
    }))

    const snapPoint = (value, velocity, points) => {
        "worklet";
        const point = value + 0.2 * (velocity / 5)
        const deltas = points.map((p) => Math.abs(point - p))
        const minDelta = Math.min.apply(null, deltas)
        return points.filter((p) => Math.abs(point - p) === minDelta)[0]
    }

     const swipeGesture =
           Gesture.Pan()
                .activeOffsetX([-8, 5])
                .failOffsetY([-30, 30])
                .onBegin(() => {startX.value = translateX.value})
                .onUpdate(
                    (event) => {
                        translateX.value = Math.min(0, startX.value + event.translationX)
                    })
                .onEnd(
                    (event) => {
                        const dest = snapPoint(
                            translateX.value,
                            event.velocityX,
                            [-windowWidth - 10, -windowWidth + 50, 0]
                        )
                        translateX.value = withSpring(dest, { velocity: event.velocityX })
                        if (dest < -windowWidth) {
                            runOnJS(onDelete)(idx)
                        }
                    })

    return onDelete ? (
        <GestureDetector gesture={swipeGesture} >
            <Animated.View style={moveStyle} >
                <HStack space='lg' className='w-full px-0'>
                    <ListElement idx={idx} element={element} avatar={avatar} marked={marked} tag={tag} />
                    <TouchableWithoutFeedback style={{ flex: 1, width: windowWidth + 20, justifyContent: 'center', backgroundColor: '#D60000' }}>
                        <IconM className="ml-10 text-4xl text-secondary-50" name='delete' />
                    </TouchableWithoutFeedback>
                </HStack>
            </Animated.View>
        </GestureDetector>
    ) : (
        <ListElement idx={idx} element={element} avatar={avatar} marked={marked} />
    );
}
